import type { ComputedRef, Ref } from 'vue'
import { computed } from 'vue'
import type { MetalCode, ReadyToGoRingFragment } from '@/graphql/api'
import { useRoutes } from '@/router/routes'
import type { Breadcrumb } from '@/components/ui/Breadcrumbs.vue'

export function useReadyToGoRingBreadcrumbs(
    ring: Readonly<Ref<ReadyToGoRingFragment | undefined | null>>,
    metal: Readonly<Ref<MetalCode>>
): ComputedRef<Breadcrumb[]> {
    const routes = useRoutes()

    return computed<Breadcrumb[]>(() =>
        ring.value?.isReadyToShip
            ? []
            : [
                  {
                      // TODO translate
                      title: 'Home',
                      to: routes.home(),
                  },
                  {
                      // TODO translate
                      title: 'Express Rings',
                      to: routes.readyToGoRings(),
                  },
                  {
                      title: ring.value?.primaryMetal.translation.name || '',
                      to: routes.readyToGoRings(metal.value),
                  },
                  {
                      title: ring.value?.productName || '',
                  },
              ]
    )
}
